module.exports = __webpack_public_path__ + "img/dropsBanner_1920.1cf2886a.png";